import { CircleAlert } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../atoms/button/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../atoms/dialog/dialog';

interface IUrgentHelpButtonProps {
  readonly className?: string;
  readonly 'data-testid'?: string;
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
}

function DialogContentSection(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div>
        <strong className="mb-2">{t('ui-components.urgentHelpButton.talkToSomeoneTitle')}</strong>
        <p className="ml-4">{t('ui-components.urgentHelpButton.callSamaritans')}</p>
      </div>
      <div>
        <strong className="mb-2">{t('ui-components.urgentHelpButton.urgentHelpTitle')}</strong>
        <p className="ml-4">{t('ui-components.urgentHelpButton.callHelp')}</p>
      </div>
      <div>
        <strong className="mb-2">{t('ui-components.urgentHelpButton.emergencyTitle')}</strong>
        <p className="ml-4">{t('ui-components.urgentHelpButton.callUrgentHelp')}</p>
      </div>
      <p>{t('ui-components.urgentHelpButton.crisisTeamText')}</p>
    </div>
  );
}

function UrgentHelpButton({
  className,
  'data-testid': testId,
  open,
  onOpenChange,
}: IUrgentHelpButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogTrigger asChild>
        <Button
          appearance="secondary"
          aria-label={t('ui-components.urgentHelpButton.buttonText')}
          className={className}
          data-testid={testId}
          icon={CircleAlert}
          size="sm"
        >
          {t('ui-components.urgentHelpButton.buttonText')}
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby={undefined}
        className="sm:max-w-[425px]"
        style={{ maxHeight: '90vh', overflowY: 'auto' }}
      >
        <DialogHeader>
          <DialogTitle>{t('ui-components.urgentHelpButton.title')}</DialogTitle>
        </DialogHeader>
        <DialogContentSection />
      </DialogContent>
    </Dialog>
  );
}

UrgentHelpButton.displayName = 'UrgentHelpButton';

export type { IUrgentHelpButtonProps };
export { UrgentHelpButton };
